import {
  CREATE_NOTIFICATION_SUCCESS,
  CLEAR_NOTIFICATION_SUCCESS
} from '../actions/notifications';

const notifications = (state = [], action) => {
  switch (action.type) {
    case CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        messages: action.messages,
        error: false
      };
    case CLEAR_NOTIFICATION_SUCCESS:
      return {
        ...state,
        messages: [],
        error: false
      };
    default:
      return state;
  }
};

export default notifications;



// WEBPACK FOOTER //
// ./src/reducers/notifications.js